<list-view *ngIf="listeTypes" [liste]="listeTypes"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
